'use client';

import React from 'react';
import { Boxes, Clock } from 'lucide-react';

export default function InventoryAddHeader() {
  const now = new Date();
  const dateStr = now?.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
  const timeStr = now?.toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit', hour12: true });

  return (
    <header className="flex items-center justify-between px-6 py-4 border-b border-border bg-card flex-shrink-0">
      <div className="flex items-center gap-3">
        <div className="w-9 h-9 rounded-lg bg-primary/15 flex items-center justify-center">
          <Boxes size={20} className="text-primary" />
        </div>
        <div>
          <h1 className="text-base font-bold text-foreground tracking-tight">Add Inventory Items</h1>
          <p className="text-2xs text-muted-foreground">Select a GRN · Enter item details · Submit for QC review</p>
        </div>
      </div>
      <div className="flex items-center gap-1.5 text-xs text-muted-foreground">
        <Clock size={13} />
        <span>{dateStr} · {timeStr}</span>
      </div>
    </header>
  );
}
